import 'bootstrap';
import 'bootstrap-select';
import 'bootstrap-datepicker';

import 'datatables.net';
import 'datatables.net-bs4';
import 'datatables.net-rowgroup';
import 'datatables.net-rowgroup-bs4';
import 'datatables.net-fixedcolumns';
import 'datatables.net-fixedcolumns-bs4';
//import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-scroller';
import 'datatables.net-fixedheader';
import 'datatables.net-fixedheader-bs4';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons-bs4';

import 'jstree';

import 'reflect-metadata'; //used by class-transformer to facilitate json-to-object serialization

import 'bootstrap-select';

import 'leaflet';
import 'leaflet-svg-shape-markers/dist/leaflet-svg-shape-markers.min.js';
import 'leaflet.vectorgrid/dist/Leaflet.VectorGrid.bundled.js';
import 'leaflet-extra-markers';
import 'leaflet.markercluster/dist/leaflet.markercluster.js';


// EXPORTS

import { DocumentTreeLoader } from './components/document-tree/document-tree-loader'; export { DocumentTreeLoader };
import { DocumentLibraryLoader, DocumentLibraryLoaderV2, DocumentLibraryLoaderWithSharepoint } from './components/document-library/document-library-loader'; export { DocumentLibraryLoader, DocumentLibraryLoaderV2, DocumentLibraryLoaderWithSharepoint};
import { Carousel } from './components/carousel/carousel'; export { Carousel };
import { DocumentLibraryMemberPage } from './components/document-library/document-library-members'; export { DocumentLibraryMemberPage }
import { EditDocumentLibraryMemberPage } from "./components/document-library/edit-document-library-members"; export { EditDocumentLibraryMemberPage };
import { EditDocumentTreeLoader } from "./components/document-tree/editable-document-tree/edit-document-tree"; export { EditDocumentTreeLoader };

// SCRIPTS
import './scripts/font-awesome';
import './scripts/date-functions';
import './scripts/number-functions';
import './scripts/table-functions';
import './components/scroll-to-top/scroll-to-top';



// STYLES
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.standalone.min.css';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.min.css';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css';
import 'datatables.net-scroller-bs4/css/scroller.bootstrap4.min.css';
import 'datatables.net-fixedcolumns-bs4/css/fixedColumns.bootstrap4.min.css';
import 'datatables.net-fixedheader-bs4/css/fixedHeader.bootstrap4.min.css';
import 'highcharts/css/highcharts.css';
import 'jstree/dist/themes/default/style.min.css';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'swiper/swiper-bundle.min.css';


import './styles/_base.scss';
import './styles/variables.scss';
import './styles/shared.scss';

import './styles/elements/nav-bar.scss';
import './styles/elements/footer.scss';
import './styles/elements/button.scss';
import './styles/elements/headings.scss';
import './styles/elements/footer.scss';
import './styles/elements/data-table.scss';
import './styles/elements/filter-section.scss';
import './styles/elements/document-tree.scss';
import './styles/elements/affiliation-selector.scss';
import './styles/elements/pathogen-selector.scss';
import './styles/elements/dropdowns.scss';
import './styles/elements/bio-card.scss';
import './styles/elements/accordion.scss';
import './styles/elements/image-text-boxes.scss';
import './styles/elements/pill-list.scss';
import './styles/elements/list-management-modals.scss';
import './styles/elements/teams-access-modal.scss';
import './styles/elements/edit-table.scss';


import './components/scroll-to-top/scroll-to-top.scss';
import './components/document-tree/document-tree.scss';
import './components/carousel/carousel.scss';
import './components/document-library/document-library-expand.scss';
import './components/sign-up/sign-up-modal.scss';
import './components/document-tree/editable-document-tree/edit-document-tree.scss';


// AUTH MODULE -- imported here to avoid having a separate auth.* bundle
import '../auth/pages/login/login.scss';
import '../auth/components/user-header/user-header.scss';
import '../auth/pages/profile/profile.scss';
import '../auth/pages/request-account/request-account.scss';
import { ExpertisePage } from "../auth/pages/profile/scripts/expertise.page"; export { ExpertisePage };
import { ExpertiseAlertPage } from "../shared/components/expertise-alert/expertise-alert.page"; export { ExpertiseAlertPage };
import { AffiliationsPage } from "../auth/pages/profile/scripts/affiliations.page"; export { AffiliationsPage };
import { UserDegreesPage } from "../auth/pages/profile/scripts/user-degrees.page"; export { UserDegreesPage };
import { UserOrganizationPage } from "../auth/pages/profile/scripts/user-organization.page"; export { UserOrganizationPage };
import { ConfidentialityPage } from "../auth/pages/profile/scripts/confidentiality.page"; export { ConfidentialityPage };
import { RequestAccountPage } from "../auth/pages/request-account/request-account.page";import exp from 'constants';
 export { RequestAccountPage };

